import { QueryClient } from "react-query";
import toastError from "../errors/toastError";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      cacheTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
      onError: (err) => toastError(err),
    },
    mutations: {
      onError: (err) => toastError(err),
    },
  },
});

export default queryClient;
